import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileExpectedObj } from 'ui-ng-content-tile';
import { IDatasource, Query } from 'utility-ts-orm';
import { Conversation } from '../builders/conversation_builder';
import { IConversationDatasourceModel } from '../conversations_interface';
import { ConversationPriorityFeedStrategy } from '../strategies/conversation_priority_feed_strategy';

export class ConversationsPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;
  private _count: number;

  constructor(private ngConversationDatastore: IDatasource<Conversation, IConversationDatasourceModel>) {
    Query.registerQuery(this, this.ngConversationDatastore);
  }

  run(): this {
    // only update unread count when the filter is set to all
    if (this.ngConversationDatastore.model.filter === 'all') {
      this._count = this.ngConversationDatastore.model.unreadCount;
    }
    const isActive = this._count > 0;
    this._result = {
      icon: { type: 'paper_plane', theme: 'green' },
      isOverdue: false,
      isActive,
      ...this._generatePriorityFeedItemForConversations()
    };
    return this;
  }

  get count() {
    return this._count;
  }

  get result() {
    return this._result;
  }

  private _generatePriorityFeedItemForConversations() {
    const strategy =
      this.count === 1
        ? ConversationPriorityFeedStrategy.getByKey('THREAD')
        : ConversationPriorityFeedStrategy.getByKey('CONVERSATION');
    return {
      text: {
        title: strategy.title(this._count),
        subTitle: strategy.subTitle
      },
      action: {
        state: strategy.state,
        params: strategy.params
      }
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/queries/conversations_priority_feed_query.ts